export default (value) => {
    if (value) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'visible';
        document.documentElement.style.overflow = 'visible';
    }
};
